document.addEventListener('DOMContentLoaded', () => {
    const form = document.querySelector<HTMLFormElement>('.js-quickBooking');
    if (!form) return;

    form.addEventListener('submit', (e) => {
        e.preventDefault();

        const rawDate = (form.querySelector<HTMLInputElement>('#date'))?.value ?? '';
        const time = (form.querySelector<HTMLSelectElement>('#time'))?.value ?? '';
        const duration = (form.querySelector<HTMLSelectElement>('#guests'))?.value ?? '';

        // flatpickr liefert "d.m.Y" → umwandeln in "YYYY-MM-DD"
        const [day, month, year] = rawDate.split('.');
        const date = `${year}-${month}-${day}`;

        const params = new URLSearchParams({ date, time, duration });
        window.location.href = `https://booking.nesse-office.de/conference?${params}`;
    });
});
